module.exports = __webpack_public_path__ + "img/862-3f2e57.png";